import VALIDATION_ERRORS from "@/data/validationErrors";

/**
 * Allowed symbols, needs to match PasswordPolicy.php in BE
 */
export const PASSWORD_SYMBOLS_ALLOWED = ",.?~!@#$%^&*_";
const MIN_NAME_TOKEN_LENGTH = 3;

/** At least one allowed symbol */
const SYMBOL_CHAR_RE = /[,.?~!@#$%^&*_]/;

/** Letters, digits, and allowed symbols only */
const ALLOWED_PASSWORD_RE = /^[a-zA-Z0-9,.?~!@#$%^&*_]+$/;

function normalizeAlphaNumeric(value) {
  return String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]/g, "");
}

/**
 * Returns user-facing error strings for password policy
 */
export function getPasswordPolicyErrors(password, nameParts = []) {
  const p = typeof password === "string" ? password : "";
  const errors = [];
  if (p.length < 12) {
    errors.push(VALIDATION_ERRORS.PASSWORD_LENGTH_MIN);
  }
  if (!/[a-z]/.test(p)) {
    errors.push(VALIDATION_ERRORS.PASSWORD_REQUIRE_LOWER);
  }
  if (!/[A-Z]/.test(p)) {
    errors.push(VALIDATION_ERRORS.PASSWORD_REQUIRE_UPPER);
  }
  if (!/[0-9]/.test(p)) {
    errors.push(VALIDATION_ERRORS.PASSWORD_REQUIRE_DIGIT);
  }
  if (!ALLOWED_PASSWORD_RE.test(p)) {
    errors.push(VALIDATION_ERRORS.PASSWORD_INVALID_CHAR);
  } else if (!SYMBOL_CHAR_RE.test(p)) {
    errors.push(VALIDATION_ERRORS.PASSWORD_REQUIRE_SYMBOL);
  }

  const normalizedPassword = normalizeAlphaNumeric(p);
  const hasName = (nameParts || []).some((part) => {
    const token = normalizeAlphaNumeric(part);
    return token.length >= MIN_NAME_TOKEN_LENGTH && normalizedPassword.includes(token);
  });
  if (hasName) {
    errors.push(VALIDATION_ERRORS.PASSWORD_CONTAINS_NAME);
  }
  return errors;
}
